"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var queryString = require("query-string");
var apiConfig_1 = require("./apiConfig");
/**
 * 聪明派API客户端
 *
 * @class ApiClient
 */
var SlmApiClient = /** @class */ (function (_super) {
    __extends(SlmApiClient, _super);
    function SlmApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SlmApiClient.prototype.getSLMRedpackAmount = function (slmName) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/slm/" + slmName;
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    SlmApiClient.prototype.slmReceiveCoupon = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/slm/coupon/receive";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, data: data, method: 'POST' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    SlmApiClient.prototype.slmReceiveCouponPoint = function (slmName, data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/slm/activity/" + slmName + "/coupon/receive";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, data: data, method: 'POST' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 获取优惠券列表
     * @returns
     * @memberof URLs
     */
    SlmApiClient.prototype.getCouponList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/coupons";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    SlmApiClient.prototype.getCoupon = function (slmName) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/slm/" + slmName + "/relationship/received-coupon";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    SlmApiClient.prototype.getCouponPoint = function (slmName) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/slm/activity/" + slmName + "/relationship/received-coupon";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 获取用户优惠券数量（剩余可发放、总数量）
     * @param {string} uuid
     * @returns
     * @memberof URLs
     */
    SlmApiClient.prototype.getUserCoupons = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/marketing-activity/" + uuid + "/coupon";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 获取优惠详情
     * @param {string} couponId
     * @returns
     * @memberof URLs
     */
    SlmApiClient.prototype.getQuote = function (skuId, couponId) {
        return __awaiter(this, void 0, void 0, function () {
            var query, url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = queryString.stringify({ couponId: couponId });
                        url = SlmApiClient.API_BASE_URL + "/orders/sku/" + skuId + "/quote?" + query;
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    SlmApiClient.prototype.selectedAddress = function (activityId, recordId, data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/marketing-activity/" + activityId + "/address/" + recordId;
                        return [4 /*yield*/, this.requestAdaptor({ url: url, data: data, method: 'POST' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 获取推荐分销限时折扣
     * @returns
     * @memberof URLs
     */
    SlmApiClient.prototype.getSlmDiscount = function (relationshipId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/slm/relationship/" + relationshipId + "/coupon";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data || {}];
                }
            });
        });
    };
    SlmApiClient.prototype.getSLMRelationships = function (slmName) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/slm/" + slmName + "/relationships";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    SlmApiClient.prototype.getSLMCustom = function (slmName) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/slm/" + slmName + "/custom/coupon";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    SlmApiClient.prototype.saveSLMCustom = function (slmName, data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/slm/" + slmName + "/custom/coupon";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, data: data, method: 'POST' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /*
     * 获取用积分邀请获得关系
     */
    SlmApiClient.prototype.getPointSlmRelations = function (slmName) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/slm/activity/" + slmName + "/relationships";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 获取推荐分销课程skuGroupName
     * @returns
     * @memberof URLs
     */
    SlmApiClient.prototype.getSlmSkuGroupName = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/marketing-activity/new-point/slm/" + data.slmName + "?inviterUuid=" + data.inviterUuid;
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    SlmApiClient.prototype.getSlmReceivedCoupon = function (slmName) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/slm/activity/" + slmName + "/relationship/received-coupon";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    SlmApiClient.prototype.slmBindRelationship = function (slmName, data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/slm/" + slmName + "/bind";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, data: data, method: 'POST' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 获取用户分销活动列表
     */
    SlmApiClient.prototype.getUserSlmActivities = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/slm/activities";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 获取用户特权
     * @returns
     * @memberof URLs
     */
    SlmApiClient.prototype.getUserPrivileges = function (type) {
        return __awaiter(this, void 0, void 0, function () {
            var query, url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = queryString.stringify({ type: type });
                        url = SlmApiClient.API_BASE_URL + "/marketing-activity/privileges?" + query;
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    SlmApiClient.prototype.notifyReward = function (activityId, recordId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/marketing-activity/" + activityId + "/view/" + recordId;
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'POST' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    SlmApiClient.prototype.getRefundPlusDetail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/marketing-activity/refund-plus";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    SlmApiClient.prototype.getRefundV4Detail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/marketing-activity/refund-v4";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    SlmApiClient.prototype.claimReward = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/marketing-activity/" + data.activityId + "/participation-reward";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, data: data, method: 'POST' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    SlmApiClient.prototype.getParticipationReward = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/marketing-activity/" + data.activityId + "/participation-reward";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, data: data, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 获取分销优惠券
     * @returns
     * @memberof URLs
     */
    SlmApiClient.prototype.getSlmCoupon = function (templateName) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = SlmApiClient.API_BASE_URL + "/coupons?templateName=" + templateName;
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    return SlmApiClient;
}(apiConfig_1.ApiConfig));
exports.SlmApiClient = SlmApiClient;
//# sourceMappingURL=slm.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/services/api/slm.js
// module id = 1019
// module chunks = 0